import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NavigateBackComponent } from './navigateBack.component';

@NgModule({
  imports: [CommonModule],
  declarations: [NavigateBackComponent],
  exports: [NavigateBackComponent],
})
export class NavigateBackModule {}
